/** The client portal's calls: read-only, always for one client the login is scoped to. */

import { apiCall, orgPath } from '../api.ts';
import type {
  Catalogue,
  CompareSetting,
  DocumentKind,
  Page,
  RangeSetting,
  WidgetResult,
} from '../reports/reports-api.ts';

export interface Branding {
  display_name: string;
  accent: string | null;
  logo: string | null;
}

export interface PortalClient {
  id: string;
  name: string;
}

export interface SharedDocument {
  id: string;
  name: string;
  kind: DocumentKind;
  settings: { range?: RangeSetting; compare?: CompareSetting; timezone?: string };
  /** Only on a single document, not in the list. */
  theme?: Record<string, unknown>;
  updated_at: string;
}

const client = (org: string, clientId: string, path = '') =>
  orgPath(org, `/portal/clients/${clientId}${path}`);

export const portalApi = {
  home: (org: string) =>
    apiCall<{ clients: PortalClient[]; branding: Branding; catalogue: Catalogue }>(
      orgPath(org, '/portal'),
    ),
  documents: (org: string, clientId: string) =>
    apiCall<{ items: SharedDocument[] }>(client(org, clientId, '/documents')),
  document: (org: string, clientId: string, id: string) =>
    apiCall<{ document: SharedDocument & { business_unit_id: string }; pages: Page[] }>(
      client(org, clientId, `/documents/${id}`),
    ),
  query: (
    org: string,
    clientId: string,
    id: string,
    input: { page: number; range?: RangeSetting; compare?: CompareSetting },
  ) =>
    apiCall<{ results: WidgetResult[]; today: string; range: { from: string; to: string } }>(
      client(org, clientId, `/documents/${id}/query`),
      {
        method: 'POST',
        body: JSON.stringify(input),
      },
    ),
};
